/* eslint-disable react/destructuring-assignment */
import React from 'react'
import { connect } from 'react-redux'
import { Helmet } from 'react-helmet-async'
import { injectIntl } from 'react-intl'
import { Button } from 'reactstrap'
import { termsActions } from '../../redux/actions'
import FormattedMessage from '../../components/FormattedMessage/FormattedMessage'
import TermsModal from '../../components/Modal/TermsModal/TermsModal'
import Loader from '../../components/Loader/Loader'

import './Terms.scss'

class Terms extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      current: {},
      modalOpen: false,
      termsGroup: [],
    }
  }

  componentDidMount = async () => {
    const { getTerms } = this.props
    const termsGroup = await getTerms()
    this.setState({ termsGroup })
  }

  setCurrent = current => {
    this.setState({ current })
    this.toggleModal()
  }

  toggleModal = () => {
    this.setState(state => ({
      modalOpen: !state.modalOpen,
    }))
  }

  renderLinks = (terms, groupId) =>
    terms.map((link, index) => {
      const linkKey = `${groupId}-${index}`

      return (
        <div className="my-3 link" key={linkKey}>
          <i className="fas fa-sm fa-caret-right" aria-hidden="true" />
          <span className="term-link-separator" aria-hidden="true">
            {' '}
          </span>
          <Button
            color="link"
            className="term-link p-0 border-0"
            aria-label={`${link.name}, open in modal`}
            onClick={() => {
              this.setCurrent(link)
            }}
            style={{ textDecoration: 'none', verticalAlign: 'baseline' }}
          >
            <span className="term-link-label">{link.name}</span>
            <i className="fas fa-sm fa-external-link-alt term-link-icon" aria-hidden="true" />
          </Button>
        </div>
      )
    })

  renderTermsGroup = () => {
    const { termsGroup } = this.state
    return termsGroup.map(termGroup => (
      <div key={termGroup.id} className="my-5" role="region" aria-label={termGroup.title}>
        <h4 aria-level="2">{termGroup.title}</h4>
        {this.renderLinks(termGroup.terms, termGroup.id)}
      </div>
    ))
  }

  render() {
    const { intl } = this.props
    const { modalOpen, current, termsGroup } = this.state
    const label = intl.formatMessage({ id: 'page.termsPage.title.heroTitle' })
    return (
      <div className="terms-page" role="main" aria-label="Terms Main">
        <Helmet>
          <title>{label}</title>
        </Helmet>
        <TermsModal isOpen={modalOpen} toggle={this.toggleModal} current={current} />
        <div className="container mt-5 mb-5">
          <h1 className="page-title">
            <FormattedMessage id="page.termsPage.title.heroTitle" />
          </h1>
          <h4 aria-level="2">
            <FormattedMessage id="page.termsPage.title.description" />
          </h4>
          <p>
            <FormattedMessage id="page.termsPage.title.note" />
          </p>
          {termsGroup && termsGroup.length > 0 ? (
            this.renderTermsGroup()
          ) : (
            <Loader aria-live="polite" noBorder />
          )}
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  getTerms: (...args) => dispatch(termsActions.getTerms(...args)),
})

export default injectIntl(connect(null, mapDispatchToProps)(Terms))
